export default __webpack_public_path__ + "static/media/broomfield-openspaces.162099b2.eot";